<template>
  <section class="content">
    <div class="card card-primary">
      <div class="card-body">
        <div class="row" style="display: flex; justify-content: space-between;">
          <h4>
            <button type="button" class="btn" @click="back()">
              <i class="fas fa-arrow-left"></i>
            </button>
            <span class="bd-content-title">Status Koneksi WhatsApp</span>
          </h4>
          <button v-if="device.status !== 1 && !loading" type="button" class="btn btn-outline-primary" @click="scanQR()">Login</button>
        </div>
        <div style="border-bottom: 2px solid #D9D9D9; padding-top: 20px;"></div>
        <div style="padding-top: 20px;">
          <div class="row">
            <div class="form-group col-auto col-sm-auto">
              <img :src="require(`../assets/img/whatsapp.png`)" style="max-width: 100%; max-height: 110px;" alt="">
            </div>
            <div class="form-group col-auto col-sm-auto" style="display: flex; align-items: center;">
              <div>
                <h6>
                  <span class="text-xs bd-content-title">Pastikan WhatsApp Anda tetap terhubung</span>
                </h6>
                <span class="text-xs">Koneksi akan otomatis terputus jika Aplikasi WhatsApp di smartphone kamu tidak
                  aktif lebih dari 14 hari</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-4">
          <div class="card card-primary">
            <div class="card-body">
                <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                  <button class="nav-link active" id="v-pills-delay-tab" data-toggle="pill" data-target="#v-pills-delay"
                    type="button" role="tab" aria-controls="v-pills-delay" aria-selected="true" style="border: none; margin-bottom: 10px; outline: none;">Send Message Delay
                  </button>
                  <button class="nav-link" id="v-pills-cs-tab" data-toggle="pill" data-target="#v-pills-cs" type="button"
                    role="tab" aria-controls="v-pills-cs" aria-selected="false" style="border: none; margin-bottom: 10px; outline: none;">Setting CS
                  </button>
                  <button class="nav-link" id="v-pills-notification-tab" data-toggle="pill"
                    data-target="#v-pills-notification" type="button" role="tab" aria-controls="v-pills-notification"
                    aria-selected="false" style="border: none; margin-bottom: 10px; outline: none;">Setting Notifikasi
                  </button>
                </div>
            </div>
          </div>
        </div>
        <form class="col-sm-8">
          <div class="card card-primary">
            <div class="card-body">
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <h5 class="card-title">Setting {{ device.device_name }} ({{ device.phone }})</h5>
                <div v-if="!loading">
                  <div v-if="device.status === 1" class="badge badge-success">Connected</div>
                  <div v-else class="badge badge-danger">Disconnected</div>
                </div>
              </div>
              <hr>
              <div class="tab-content" id="v-pills-tabContent">
                <div class="tab-pane fade show active" id="v-pills-delay" role="tabpanel"
                  aria-labelledby="v-pills-delay-tab">
                  <div class="form-row">
                    <div class="col-md-6 mb-3">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="delaySwitch" v-model="device.status_save_limiter" :true-value="1" :false-value="0">
                        <label class="custom-control-label" for="delaySwitch">Send Message Delay</label>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3"></div>
                  </div>
                  <div class="form-row">
                    <div class="col-md-6 mb-3">
                      <label for="delaySelect">Pilih menit delay pengiriman antar pesan</label>
                      <select class="form-control" id="delaySelect" v-model="device.schedule_limiter">
                        <option value="60">1 menit</option>
                        <option value="180">3 menit</option>
                        <option value="300">5 menit</option>
                      </select>
                    </div>
                    <div class="col-md-6 mb-3"></div>
                  </div>
                </div>
                <div class="tab-pane fade" id="v-pills-cs" role="tabpanel" aria-labelledby="v-pills-cs-tab">
                  <p>Pengaturan ini digunakan untuk memilih (CS) yang akan bertanggung jawab atas pesan yang dikirimkan
                    oleh shipper</p>
                  <div class="form-row">
                    <div class="col-md-6 mb-3">
                      <label for="csSelect">Pilih CS</label>
                      <select class="form-control" id="csSelect" v-model="device.cs_code">
                        <option :value="null">Semua</option>
                        <option v-for="cs in csList" :value="cs.code">{{ cs.nama }}</option>
                      </select>
                    </div>
                    <div class="col-md-6 mb-3"></div>
                  </div>
                </div>
                <div class="tab-pane fade" id="v-pills-notification" role="tabpanel"
                  aria-labelledby="v-pills-notification-tab">
                  <p>Pengaturan notifikasi ini memungkinkan shipper untuk mengirim pesan kepada pengguna mengenai status
                    terbaru paket mereka</p>
                  <div class="form-row">
                    <div class="col-md-6 mb-3">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="pickupCheckbox" style="accent-color: var(--primary);"
                          v-model="packageStatus" :value="0">
                        <label class="form-check-label" for="pickupCheckbox">
                          Paket menunggu pickup
                        </label>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="courierPickupCheckbox" style="accent-color: var(--primary);"
                          v-model="packageStatus" :value="1">
                        <label class="form-check-label" for="courierPickupCheckbox">
                          Paket diambil kurir
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col-md-6 mb-3">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="inTransitCheckbox" style="accent-color: var(--primary);"
                          v-model="packageStatus" :value="6">
                        <label class="form-check-label" for="inTransitCheckbox">
                          Paket proses perjalanan
                        </label>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="problemCheckbox" style="accent-color: var(--primary);"
                          v-model="packageStatus" :value="5">
                        <label class="form-check-label" for="problemCheckbox">
                          Paket mengalami problem
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col-md-6 mb-3">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="courierDeliveryCheckbox" style="accent-color: var(--primary);" disabled>
                        <label class="form-check-label" for="courierDeliveryCheckbox">
                          Paket diantar oleh kurir
                        </label>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="returnProcessCheckbox" style="accent-color: var(--primary);"
                          v-model="packageStatus" :value="3">
                        <label class="form-check-label" for="returnProcessCheckbox">
                          Paket diproses retur
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button type="button" class="btn btn-primary btn-lg" :disabled="loading || saving" @click="save()">Simpan</button>
            </div>
          </div>
          <div class="modal fade" ref="savedModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-body">
                  <img src="../assets/img/ok.svg" class="d-block m-auto"  alt=""/>
                  <br />
                  <h5 style="text-align: center;">
                    Data kamu berhasil disimpan
                  </h5>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-primary w-100" data-dismiss="modal">Kembali</button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal" tabindex="-1" role="dialog" ref="scanQR" data-backdrop="static">
            <WhatsAppQRScan ref="waQR" @tutorialClicked="tutorial()" @afterScan="afterScan()" @rescan="scanQR()" />
          </div>
          <div class="modal fade" ref="maintenanceModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-body">
                  <img src="../assets/img/maintenance.svg" class="d-block m-auto"  alt=""/>
                  <br />
                  <h5 style="text-align: center;">
                    Mohon maaf, fitur notifikasi WhatsApp sedang dalam perbaikan. Silakan coba lagi nanti
                  </h5>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-primary w-100" data-dismiss="modal">Kembali ke Beranda</button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal fade" ref="errorModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-body">
                  <img src="../assets/img/error.png" class="d-block m-auto"  alt=""/>
                  <br />
                  <h5 style="text-align: center;">
                    Terjadi kesalahan saat memverifikasi nomor telepon Anda. Silakan coba lagi dengan nomor yang sama
                  </h5>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-primary w-100" data-dismiss="modal">Scan Kembali</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { authFetch } from "@/libs/hxcore";
import $ from 'jquery';
import WhatsAppQRScan from '../dialog/WhatsAppQRScan.vue';

export default {
  name: "WhatsAppSetting",
  components: {
    WhatsAppQRScan
  },
  data() {
    return {
      device: {
        id: null,
        phone: null,
        status: null,
        device_name: null,
        schedule_limiter: null,
        status_save_limiter: null,
        limit_message: null,
        package_status: null,
        cs_code: null
      },
      csList: [],
      packageStatus: [],
      loading: true,
      saving: false
    }
  },
  mounted() {
    this.loadDevice();
    this.loadCSList();
  },
  methods: {
    back() {
      this.$router.push({ path: `/settings/whatsapp` });
    },
    async loadDevice() {
      this.loading = true;

      try {
        const response = await authFetch(`/whatsapp/notification_device/${this.$route.params?.id}`);
        const json = await response.json();

        this.device = json?.data ?? {};
        this.packageStatus = this.device.package_status ? this.device.package_status.split(',').map(Number) : [];
        this.loading = false;
      } catch (_) {
        this.loading = false;
      }
    },
    async loadCSList() {
      try {
        const response = await authFetch(`/shipper/user`);
        const json = await response.json();

        this.csList = json?.data ?? [];
      } catch (_) {}
    },
    async save() {
      try {
        this.saving = true;
        this.device.package_status = this.packageStatus.join(',');
        const response = await authFetch(`/whatsapp/notification_device/${this.$route.params?.id}`, {
          method: 'PUT',
          body: Object.keys(this.device).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.device[key] ?? '')).join('&')
        });
        const json = await response.json();

        if (json.success) {
          $(this.$refs.savedModal).modal('show');
        } else {
          $(this.$refs.errorModal).modal('show');
        }

        this.saving = false;
      } catch (_) {
        $(this.$refs.errorModal).modal('show');
        this.saving = false;
      }
    },
    tutorial() {
      // this.statusTutorial = true;
      $(this.$refs.scanQR).modal("hide");
      
      if (this.$refs.waQR.qr_code === '') {
        this.$refs.waQR.getQRCode();
      }
    },
    afterScan() {
      $(this.$refs.scanQR).modal("hide");
      setTimeout(() => {
        this.loadDevice();
      }, 10000);
    },
    scanQR() {
      $(this.$refs.scanQR).modal("show");

      if (this.$refs.waQR.qr_code === '') {
        this.$refs.waQR.phone = this.device.phone;
        this.$refs.waQR.getQRCode();
      }
    },
  }
}
</script>

<style scoped>
.text-xs {
  margin-bottom: 10px;
  font-size: 1rem !important;
}

.modal-dialog {
  max-width: 800px;
  margin: 1.75rem auto;
}
</style>